import { render, staticRenderFns } from "./ProspectSetting.vue?vue&type=template&id=153c9c8c&scoped=true"
import script from "./ProspectSetting.vue?vue&type=script&lang=js"
export * from "./ProspectSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c9c8c",
  null
  
)

export default component.exports